import { render } from "./OurHistory.vue?vue&type=template&id=6c2e0338&scoped=true"
import script from "./OurHistory.vue?vue&type=script&lang=js"
export * from "./OurHistory.vue?vue&type=script&lang=js"

import "./OurHistory.vue?vue&type=style&index=0&id=6c2e0338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2e0338"]])

export default __exports__